/* ============================================================
   AP10 Bundle Builder
   - Produktauswahl aus Kollektion mit Suche
   - Varianten-Sheet (Größe + Stil-Farbe)
   - Live-Rabattstufen (Anzeige; echte Rabatte via automatische
     Rabatte im Shopify-Admin)
   - Zubehör-Schritt + gesammelter Add-to-Cart
   ============================================================ */
(function () {
  if (customElements.get('bundle-builder')) return;

  function handleize(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9äöüß]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  class BundleBuilder extends HTMLElement {
    connectedCallback() {
      try {
        this.cfg = JSON.parse(this.querySelector('[data-bb-config]').textContent);
      } catch (e) {
        console.error('[BB] Config fehlerhaft', e);
        return;
      }

      // Rabattstufen parsen: "2:10,3:15,4:20,5:25"
      this.tiers = String(this.cfg.tiers || '')
        .split(',')
        .map((t) => {
          const p = t.split(':');
          return { qty: parseInt(p[0], 10), pct: parseInt(p[1], 10) };
        })
        .filter((t) => t.qty > 0 && t.pct > 0)
        .sort((a, b) => a.qty - b.qty);

      this.items = []; // { product, variant, qty }
      this.accSelection = {}; // accId -> { variantId, price, title }

      this.el = {
        tiers: this.querySelector('[data-bb-tiers]'),
        search: this.querySelector('[data-bb-search]'),
        grid: this.querySelector('[data-bb-grid]'),
        empty: this.querySelector('[data-bb-empty]'),
        bar: this.querySelector('[data-bb-bar]'),
        tray: this.querySelector('[data-bb-tray]'),
        compare: this.querySelector('[data-bb-compare]'),
        total: this.querySelector('[data-bb-total]'),
        save: this.querySelector('[data-bb-save]'),
        next: this.querySelector('[data-bb-next]'),
        sheet: this.querySelector('[data-bb-sheet]'),
        sheetImage: this.querySelector('[data-bb-sheet-image]'),
        sheetTitle: this.querySelector('[data-bb-sheet-title]'),
        sheetPrice: this.querySelector('[data-bb-sheet-price]'),
        sheetOptions: this.querySelector('[data-bb-sheet-options]'),
        sheetAdd: this.querySelector('[data-bb-sheet-add]'),
        accSheet: this.querySelector('[data-bb-acc-sheet]'),
        accList: this.querySelector('[data-bb-acc-list]'),
        accSummary: this.querySelector('[data-bb-acc-summary]'),
        error: this.querySelector('[data-bb-error]'),
        submit: this.querySelector('[data-bb-submit]')
      };

      this.renderTiers();
      this.renderGrid(this.cfg.products);
      this.renderAccessories();
      this.updateBar();
      this.bindEvents();
      this.hideFloatingWidgets();
    }

    /* Externe Floating-Widgets (Shopify-Inbox-Chat, Cashback) auf dieser
       Seite ausblenden — sie überlagern sonst die Sticky-Bar.
       Heuristik: fixierte, kleine Elemente am unteren Bildschirmrand.
       Geprüft werden Body-Kinder UND alle Iframes samt Wrapper-Eltern
       (Shopify Inbox rendert den Button in einem verschachtelten Iframe).
       Läuft im Intervall, weil Widgets verzögert nachladen und beim
       Einfügen oft noch 0×0 groß sind. */
    hideFloatingWidgets() {
      const self = this;
      const isProtected = (el) => {
        if (el === self || self.contains(el) || el.contains(self)) return true;
        if (el.closest && el.closest('bundle-builder, .perso-modal, .bb-sheet')) return true;
        return false;
      };
      const collect = () => {
        const set = new Set();
        document.querySelectorAll('body > *').forEach((el) => set.add(el));
        document.querySelectorAll('iframe').forEach((f) => {
          set.add(f);
          if (f.parentElement) set.add(f.parentElement);
          if (f.parentElement && f.parentElement.parentElement) set.add(f.parentElement.parentElement);
        });
        return set;
      };
      const hide = () => {
        collect().forEach((el) => {
          const tag = el.tagName;
          if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'LINK' || tag === 'BODY' || tag === 'HTML') return;
          if (isProtected(el)) return;
          let cs;
          try { cs = getComputedStyle(el); } catch (e) { return; }
          if (cs.position !== 'fixed') return;
          const r = el.getBoundingClientRect();
          if (!r.width || !r.height) return;
          const nearBottom = r.bottom > window.innerHeight - 200 && r.top > window.innerHeight * 0.4;
          const small = r.width < 420 && r.height < 320;
          if (nearBottom && small) {
            el.style.setProperty('display', 'none', 'important');
          }
        });
      };
      hide();
      this._widgetTimer = setInterval(hide, 1500);
      this._widgetObserver = new MutationObserver(() => hide());
      this._widgetObserver.observe(document.body, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      if (this._widgetTimer) clearInterval(this._widgetTimer);
      if (this._widgetObserver) this._widgetObserver.disconnect();
    }

    /* ---------------- Events ---------------- */
    bindEvents() {
      // Suche
      let searchTimer;
      this.el.search.addEventListener('input', () => {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(() => {
          const q = this.el.search.value.trim().toLowerCase();
          const filtered = q
            ? this.cfg.products.filter((p) => p.title.toLowerCase().includes(q))
            : this.cfg.products;
          this.renderGrid(filtered);
        }, 120);
      });

      // Produkt-Karte → Sheet öffnen (oder direkt hinzufügen)
      this.el.grid.addEventListener('click', (e) => {
        const card = e.target.closest('[data-bb-product]');
        if (!card) return;
        const product = this.cfg.products.find((p) => p.id === parseInt(card.dataset.bbProduct, 10));
        if (!product) return;
        if (product.singleVariant) {
          this.addItem(product, product.variants[0]);
        } else {
          this.openSheet(product);
        }
      });

      // Sheet schließen
      this.querySelectorAll('[data-bb-sheet-close]').forEach((el) =>
        el.addEventListener('click', () => this.closeSheet())
      );
      this.querySelectorAll('[data-bb-acc-close]').forEach((el) =>
        el.addEventListener('click', () => this.closeAccSheet())
      );
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        if (!this.el.accSheet.hidden) this.closeAccSheet();
        else if (!this.el.sheet.hidden) this.closeSheet();
      });

      // Sheet: Option gewählt
      this.el.sheetOptions.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-bb-opt]');
        if (!btn || btn.disabled) return;
        const group = btn.closest('[data-bb-opt-group]');
        group.querySelectorAll('[data-bb-opt]').forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        this.syncSheetState();
      });

      // Sheet: hinzufügen
      this.el.sheetAdd.addEventListener('click', () => {
        const v = this.currentSheetVariant();
        if (!v || !v.available) return;
        this.addItem(this.sheetProduct, v);
        this.closeSheet();
      });

      // Tray: Entfernen / Menge
      this.el.tray.addEventListener('click', (e) => {
        const rm = e.target.closest('[data-bb-remove]');
        if (rm) {
          const idx = parseInt(rm.dataset.bbRemove, 10);
          this.items.splice(idx, 1);
          this.updateBar();
        }
      });

      // Weiter → Zubehör-Sheet
      this.el.next.addEventListener('click', () => {
        if (this.totalQty() === 0) return;
        // Nicht manuell angepasste Zubehör-Mengen an die Bundle-Anzahl angleichen
        const q = Math.max(1, this.totalQty());
        Object.keys(this.accSelection).forEach((k) => {
          const sel = this.accSelection[k];
          if (!sel.manual) {
            sel.qty = q;
            const countEl = this.el.accList.querySelector('[data-bb-acc="' + k + '"] [data-bb-acc-count]');
            if (countEl) countEl.textContent = q;
          }
        });
        this.renderAccSummary();
        this.el.accSheet.hidden = false;
        document.body.classList.add('bb-sheet-open');
      });

      // Zubehör-Auswahl
      this.el.accList.addEventListener('click', (e) => {
        // Mengen-Stepper
        const minus = e.target.closest('[data-bb-acc-minus]');
        const plus = e.target.closest('[data-bb-acc-plus]');
        if (minus || plus) {
          e.preventDefault();
          const row = e.target.closest('[data-bb-acc]');
          const accId = parseInt(row.dataset.bbAcc, 10);
          const sel = this.accSelection[accId];
          if (!sel) return;
          sel.qty = Math.max(1, Math.min(99, (sel.qty || 1) + (plus ? 1 : -1)));
          sel.manual = true; // User hat Menge selbst angepasst → nicht mehr auto-syncen
          row.querySelector('[data-bb-acc-count]').textContent = sel.qty;
          this.renderAccSummary();
          return;
        }

        // Varianten-Buttons (z.B. Größe der Verpackung)
        const sizeBtn = e.target.closest('[data-bb-acc-variant]');
        if (sizeBtn && !sizeBtn.disabled) {
          const row = sizeBtn.closest('[data-bb-acc]');
          row.querySelectorAll('[data-bb-acc-variant]').forEach((b) => b.classList.remove('is-active'));
          sizeBtn.classList.add('is-active');
          const accId = parseInt(row.dataset.bbAcc, 10);
          const cb = row.querySelector('[data-bb-acc-check]');
          if (cb.checked && this.accSelection[accId]) {
            this.accSelection[accId].variantId = parseInt(sizeBtn.dataset.bbAccVariant, 10);
            this.accSelection[accId].price = parseInt(sizeBtn.dataset.bbAccPrice, 10);
            this.renderAccSummary();
          }
          return;
        }
      });
      this.el.accList.addEventListener('change', (e) => {
        const cb = e.target.closest('[data-bb-acc-check]');
        if (!cb) return;
        const row = cb.closest('[data-bb-acc]');
        const accId = parseInt(row.dataset.bbAcc, 10);
        if (cb.checked) {
          const activeBtn = row.querySelector('[data-bb-acc-variant].is-active') || row.querySelector('[data-bb-acc-variant]:not([disabled])');
          const defaultQty = Math.max(1, this.totalQty()); // Default: so viele wie Bundle-Produkte
          this.accSelection[accId] = {
            variantId: activeBtn
              ? parseInt(activeBtn.dataset.bbAccVariant, 10)
              : parseInt(row.dataset.defaultVariant, 10),
            price: activeBtn
              ? parseInt(activeBtn.dataset.bbAccPrice, 10)
              : parseInt(row.dataset.defaultPrice, 10),
            qty: defaultQty,
            manual: false
          };
          if (activeBtn) activeBtn.classList.add('is-active');
          row.querySelector('[data-bb-acc-count]').textContent = defaultQty;
        } else {
          delete this.accSelection[accId];
        }
        this.renderAccSummary();
      });

      // Abschluss
      this.el.submit.addEventListener('click', () => this.addAllToCart());
    }

    /* ---------------- Rabattstufen ---------------- */
    currentTier(qty) {
      let t = null;
      for (const tier of this.tiers) {
        if (qty >= tier.qty) t = tier;
      }
      return t;
    }

    nextTier(qty) {
      for (const tier of this.tiers) {
        if (qty < tier.qty) return tier;
      }
      return null;
    }

    totalQty() {
      return this.items.reduce((n, it) => n + it.qty, 0);
    }

    renderTiers() {
      const qty = this.totalQty();
      const cur = this.currentTier(qty);
      this.el.tiers.innerHTML = this.tiers
        .map((t, i) => {
          const last = i === this.tiers.length - 1;
          const active = cur && cur.qty === t.qty;
          return (
            '<div class="bb__tier' + (active ? ' is-active' : '') + '">' +
            '<span class="bb__tier-qty">' + t.qty + (last ? '+' : '') + ' Produkte</span>' +
            '<span class="bb__tier-pct">' + t.pct + '% sparen</span>' +
            '</div>'
          );
        })
        .join('');
    }

    /* ---------------- Grid ---------------- */
    renderGrid(products) {
      this.el.empty.hidden = products.length > 0;
      this.el.grid.innerHTML = products
        .map((p) => {
          const inBundle = this.items.filter((it) => it.product.id === p.id).reduce((n, it) => n + it.qty, 0);
          return (
            '<button type="button" class="bb-card" data-bb-product="' + p.id + '">' +
            '<span class="bb-card__media">' +
            '<img src="' + p.image + '" alt="" loading="lazy">' +
            (inBundle ? '<span class="bb-card__badge">' + inBundle + '</span>' : '') +
            '</span>' +
            '<span class="bb-card__title">' + p.title + '</span>' +
            '<span class="bb-card__price">ab ' + money(p.price) + '</span>' +
            '<span class="bb-card__add" aria-hidden="true">+</span>' +
            '</button>'
          );
        })
        .join('');
    }

    refreshGrid() {
      const q = this.el.search.value.trim().toLowerCase();
      const filtered = q
        ? this.cfg.products.filter((p) => p.title.toLowerCase().includes(q))
        : this.cfg.products;
      this.renderGrid(filtered);
    }

    /* ---------------- Varianten-Sheet ---------------- */
    openSheet(product) {
      this.sheetProduct = product;
      this.el.sheetImage.src = product.image;
      this.el.sheetTitle.textContent = product.title;

      // Option-Gruppen bauen (Größe = Buttons mit Preis, Stile = Farb-Swatches)
      let html = '';
      product.opts.forEach((optName, idx) => {
        const key = 'o' + (idx + 1);
        const values = [];
        product.variants.forEach((v) => {
          if (v[key] && values.indexOf(v[key]) === -1) values.push(v[key]);
        });
        if (!values.length) return;

        const isColor = optName === this.cfg.colorOption;
        const isSize = optName === this.cfg.sizeOption;

        html += '<div class="bb-opt" data-bb-opt-group data-key="' + key + '">';
        html += '<p class="bb-opt__label">' + optName + '</p>';
        html += '<div class="bb-opt__values' + (isColor ? ' bb-opt__values--swatches' : '') + '">';
        values.forEach((val, vi) => {
          if (isColor) {
            const c = this.cfg.colorMap[handleize(val)] || '#d2d2d7';
            html +=
              '<button type="button" class="bb-swatch' + (vi === 0 ? ' is-active' : '') + '" data-bb-opt data-value="' + val.replace(/"/g, '&quot;') + '" title="' + val.replace(/"/g, '&quot;') + '">' +
              '<span style="--c:' + c + '"></span>' +
              '</button>';
          } else {
            // Preis der günstigsten Variante mit diesem Wert (nur für Größen sinnvoll)
            let priceLabel = '';
            if (isSize) {
              let min = null;
              product.variants.forEach((v) => {
                if (v[key] === val && (min === null || v.price < min)) min = v.price;
              });
              if (min !== null) priceLabel = '<small>' + money(min) + '</small>';
            }
            html +=
              '<button type="button" class="bb-opt__btn' + (vi === 0 ? ' is-active' : '') + '" data-bb-opt data-value="' + val.replace(/"/g, '&quot;') + '">' +
              '<span>' + val + '</span>' + priceLabel +
              '</button>';
          }
        });
        html += '</div></div>';
      });

      this.el.sheetOptions.innerHTML = html;
      this.syncSheetState();
      this.el.sheet.hidden = false;
      document.body.classList.add('bb-sheet-open');
    }

    closeSheet() {
      this.el.sheet.hidden = true;
      if (this.el.accSheet.hidden) document.body.classList.remove('bb-sheet-open');
    }

    currentSheetVariant() {
      if (!this.sheetProduct) return null;
      const sel = {};
      this.el.sheetOptions.querySelectorAll('[data-bb-opt-group]').forEach((g) => {
        const active = g.querySelector('[data-bb-opt].is-active');
        if (active) sel[g.dataset.key] = active.dataset.value;
      });
      return (
        this.sheetProduct.variants.find((v) => {
          return Object.keys(sel).every((k) => v[k] === sel[k]);
        }) || null
      );
    }

    syncSheetState() {
      const v = this.currentSheetVariant();
      if (v) {
        this.el.sheetPrice.textContent = money(v.price) + (v.available ? '' : ' — Ausverkauft');
        this.el.sheetAdd.disabled = !v.available;
        // Variantenbild anzeigen (z.B. anderer Stil), sonst Produktbild
        const img = v.image || (this.sheetProduct && this.sheetProduct.image);
        if (img && this.el.sheetImage.src !== img) this.el.sheetImage.src = img;
      } else {
        this.el.sheetPrice.textContent = 'Nicht verfügbar';
        this.el.sheetAdd.disabled = true;
      }
    }

    /* ---------------- Bundle-State ---------------- */
    addItem(product, variant) {
      const existing = this.items.find((it) => it.variant.id === variant.id);
      if (existing) {
        existing.qty += 1;
      } else {
        this.items.push({
          product: product,
          variant: variant,
          image: variant.image || product.image,
          qty: 1
        });
      }
      this.updateBar();
    }

    updateBar() {
      const qty = this.totalQty();
      const subtotal = this.items.reduce((n, it) => n + it.variant.price * it.qty, 0);
      const tier = this.currentTier(qty);
      const next = this.nextTier(qty);
      const pct = tier ? tier.pct : 0;
      const discounted = Math.round(subtotal * (100 - pct) / 100);

      this.el.bar.hidden = qty === 0;
      this.el.total.textContent = money(discounted);
      this.el.compare.hidden = pct === 0;
      if (pct > 0) this.el.compare.textContent = money(subtotal);
      this.el.save.hidden = pct === 0;
      if (pct > 0) this.el.save.textContent = '−' + pct + '% · Du sparst ' + money(subtotal - discounted);

      // Tray (inkl. "Geister-Kachel" als Nudge zur nächsten Rabattstufe)
      let trayHtml = this.items
        .map((it, idx) => {
          const optLabel = it.product.singleVariant
            ? ''
            : [it.variant.o1, it.variant.o2].filter(Boolean).join(' · ');
          return (
            '<div class="bb-tray__item">' +
            '<img src="' + (it.image || it.product.image) + '" alt="">' +
            (it.qty > 1 ? '<span class="bb-tray__qty">' + it.qty + '</span>' : '') +
            (optLabel ? '<span class="bb-tray__opt">' + optLabel + '</span>' : '') +
            '<button type="button" class="bb-tray__remove" data-bb-remove="' + idx + '" aria-label="Entfernen">×</button>' +
            '</div>'
          );
        })
        .join('');
      if (next && qty > 0) {
        const diff = next.qty - qty;
        trayHtml +=
          '<div class="bb-tray__ghost">' +
          '<span class="bb-tray__ghost-circle">+' + diff + '</span>' +
          '<span class="bb-tray__ghost-label">bis −' + next.pct + '%</span>' +
          '</div>';
      }
      this.el.tray.innerHTML = trayHtml;

      this.renderTiers();
      this.refreshGrid();
    }

    /* ---------------- Zubehör ---------------- */
    renderAccessories() {
      const accs = this.cfg.accessories || [];
      this.el.accList.innerHTML = accs
        .map((a) => {
          const variants = a.variants.filter((v) => v.available);
          if (!variants.length) return '';
          let variantHtml = '';
          if (!a.singleVariant && a.variants.length > 1) {
            variantHtml =
              '<div class="bb-acc__variants">' +
              a.variants
                .map(
                  (v, i) =>
                    '<button type="button" class="bb-acc__variant' + (i === 0 && v.available ? ' is-active' : '') + '" data-bb-acc-variant="' + v.id + '" data-bb-acc-price="' + v.price + '"' + (v.available ? '' : ' disabled') + '>' + v.title + '</button>'
                )
                .join('') +
              '</div>';
          }
          return (
            '<label class="bb-acc__item" data-bb-acc="' + a.id + '" data-default-variant="' + variants[0].id + '" data-default-price="' + variants[0].price + '">' +
            '<input type="checkbox" data-bb-acc-check>' +
            '<span class="bb-acc__box" aria-hidden="true"><svg viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 5L4.5 8.5L11 1.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
            '<img class="bb-acc__image" src="' + a.image + '" alt="">' +
            '<span class="bb-acc__info">' +
            '<span class="bb-acc__title">' + a.title + '</span>' +
            '<span class="bb-acc__price">' + money(variants[0].price) + '</span>' +
            variantHtml +
            '</span>' +
            '<span class="bb-acc__qty" aria-label="Menge">' +
            '<button type="button" class="bb-acc__qty-btn" data-bb-acc-minus aria-label="Menge verringern">−</button>' +
            '<span class="bb-acc__qty-count" data-bb-acc-count>1</span>' +
            '<button type="button" class="bb-acc__qty-btn" data-bb-acc-plus aria-label="Menge erhöhen">+</button>' +
            '</span>' +
            '</label>'
          );
        })
        .join('');
    }

    renderAccSummary() {
      const qty = this.totalQty();
      const subtotal = this.items.reduce((n, it) => n + it.variant.price * it.qty, 0);
      const tier = this.currentTier(qty);
      const pct = tier ? tier.pct : 0;
      const discounted = Math.round(subtotal * (100 - pct) / 100);
      let accTotal = 0;
      let accPieces = 0;
      Object.keys(this.accSelection).forEach((k) => {
        const sel = this.accSelection[k];
        const q = sel.qty || 1;
        accTotal += sel.price * q;
        accPieces += q;
      });

      let html =
        '<div class="bb-acc__row"><span>' + qty + ' Poster</span><span>' +
        (pct > 0 ? '<s>' + money(subtotal) + '</s> ' : '') + money(discounted) + '</span></div>';
      if (pct > 0) {
        html += '<div class="bb-acc__row bb-acc__row--save"><span>Bundle-Rabatt (−' + pct + '%)</span><span>−' + money(subtotal - discounted) + '</span></div>';
      }
      if (accTotal > 0) {
        html += '<div class="bb-acc__row"><span>Zubehör (' + accPieces + '×)</span><span>' + money(accTotal) + '</span></div>';
      }
      html += '<div class="bb-acc__row bb-acc__row--total"><span>Gesamt</span><span>' + money(discounted + accTotal) + '</span></div>';
      html += '<p class="bb-acc__note">Der Rabatt wird automatisch im Warenkorb abgezogen.</p>';
      this.el.accSummary.innerHTML = html;
    }

    closeAccSheet() {
      this.el.accSheet.hidden = true;
      if (this.el.sheet.hidden) document.body.classList.remove('bb-sheet-open');
    }

    /* ---------------- Add to Cart ---------------- */
    showError(msg) {
      this.el.error.textContent = msg || '';
      this.el.error.hidden = !msg;
    }

    async addAllToCart() {
      if (this.totalQty() === 0) return;
      this.showError('');
      this.el.submit.disabled = true;
      this.el.submit.classList.add('is-loading');

      // Rabattstufe VOR dem Leeren der Auswahl bestimmen (für den Rabattcode)
      const tierAtSubmit = this.currentTier(this.totalQty());
      const pctAtSubmit = tierAtSubmit ? tierAtSubmit.pct : 0;

      const items = this.items.map((it) => ({ id: it.variant.id, quantity: it.qty }));
      Object.keys(this.accSelection).forEach((k) => {
        items.push({ id: this.accSelection[k].variantId, quantity: this.accSelection[k].qty || 1 });
      });

      const cart = document.querySelector('cart-drawer');
      const sections = cart && cart.getSectionsToRender
        ? cart.getSectionsToRender().map((s) => s.id)
        : ['cart-drawer', 'cart-icon-bubble'];

      try {
        // Rabattcode ZUERST anwenden (und abwarten!) — dann enthält das
        // Section-Rendering des nachfolgenden cart/add bereits die
        // reduzierten Preise, und der Kunde sieht den Rabatt sofort im
        // Warenkorb (Shopify "Discounts im Warenkorb").
        if (pctAtSubmit > 0 && this.cfg.codePrefix) {
          const code = this.cfg.codePrefix + pctAtSubmit;
          try {
            localStorage.setItem('ap10_bb', '1');
            localStorage.setItem('ap10_bb_code', code);
          } catch (e) {}
          try {
            await fetch('/discount/' + encodeURIComponent(code));
          } catch (e) {}
        }

        const res = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
        });
        const data = await res.json();
        if (!res.ok || data.status) {
          throw new Error(data.description || data.message || 'Konnte nicht in den Warenkorb gelegt werden.');
        }

        // Aufräumen + Drawer öffnen
        this.items = [];
        this.accSelection = {};
        this.el.accList.querySelectorAll('[data-bb-acc-check]').forEach((cb) => { cb.checked = false; });
        this.closeAccSheet();
        this.updateBar();

        if (cart && cart.renderContents && data.sections) {
          cart.renderContents(data);
        } else if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-builder' });
        }
      } catch (err) {
        console.error('[BB] Fehler:', err);
        this.showError(err.message || 'Etwas ist schiefgelaufen. Bitte erneut versuchen.');
      } finally {
        this.el.submit.disabled = false;
        this.el.submit.classList.remove('is-loading');
      }
    }
  }

  customElements.define('bundle-builder', BundleBuilder);
})();
